import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';

const ChatResponseDisplay = ({ answer, sources = [], theme = 'light' }) => {
  const isDarkTheme = theme === 'dark';

  return (
    <div className="chat-response">
      <div className={`prose max-w-none ${isDarkTheme ? 'prose-dark' : ''}`}>
        <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>
          {answer}
        </ReactMarkdown>
      </div>
    </div>
  );
};

export default ChatResponseDisplay;
